import { useTheme } from "@mui/material/styles";
import { SVGProps } from "react";

interface GroupIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export default function GroupIcon({ color, ...props }: GroupIconProps) {
  const theme = useTheme();
  
  // 如果没有指定颜色，使用当前主题的文本颜色
  const iconColor = color || theme.palette.mode === "dark" ? "#161A1E" : "#F2F2F2";

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none"
      {...props}
    >
      <path 
        d="M16.0001 21V19C16.0001 17.9391 15.5786 16.9217 14.8285 16.1716C14.0783 15.4214 13.0609 15 12.0001 15H6.00006C4.9392 15 3.92178 15.4214 3.17163 16.1716C2.42149 16.9217 2.00006 17.9391 2.00006 19V21" 
        stroke={iconColor} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M15.9999 3.12799C16.8577 3.35036 17.6173 3.85125 18.1596 4.55205C18.7019 5.25285 18.9961 6.11388 18.9961 6.99999C18.9961 7.8861 18.7019 8.74713 18.1596 9.44793C17.6173 10.1487 16.8577 10.6496 15.9999 10.872" 
        stroke={iconColor} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M21.9999 20.9999V18.9999C21.9993 18.1137 21.7043 17.2527 21.1613 16.5523C20.6183 15.8518 19.8581 15.3515 18.9999 15.1299" 
        stroke={iconColor} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M9.00006 11C11.2092 11 13.0001 9.20914 13.0001 7C13.0001 4.79086 11.2092 3 9.00006 3C6.79092 3 5.00006 4.79086 5.00006 7C5.00006 9.20914 6.79092 11 9.00006 11Z" 
        stroke={iconColor} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}
